// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/container/Shift/Shift.css
// module id = 1294
// module chunks = 193